export const quizSettings = {
    stageLength : {
        1: 20,
        2: 20,
        3: 20,
        4: 20
    }
};